module.exports = __webpack_public_path__ + "img/vegetable-cardoons-190x100.dc75e0a3.jpg";